import * as React from 'react';
import { Input } from 'semantic-ui-react';

import { addModifiers } from '../../../../shared/helpers';

import HOCSettingsTooltip from './HOCSettingsTooltip';

interface SettingsInputProps {
  name: string;
  pathOptions: string[];
  onChangeHandler: () => void;
  selection: boolean;
  currentValue: string;
  options: any;
  min: number;
  max: number;
  step: number;
  hasError: boolean;
}

const SettingsInput = ({ currentValue, name, onChangeHandler, min, max, step, hasError }: SettingsInputProps) => (
  <Input
    className={addModifiers('code-editor-settings__form-element-input', hasError ? ['error'] : [])}
    transparent={true}
    name={name}
    value={currentValue}
    onChange={onChangeHandler}
    type={'number'}
    min={min}
    max={max}
    step={step}
    error={hasError}
  />
);

export default HOCSettingsTooltip(SettingsInput);
